var exports = {
  "ns": "Attachment.module__attachmentWrapper___UEZXd3",
  "yf": "Attachment.module__expiredOverlay___UEZXd3",
  "ri": "Attachment.module__expiredContent___UEZXd3",
};

module.exports = exports;
